//
import { checkPermission } from "shared/imports/permissionFunctions"
import dlcKeys from "shared/profiles/tabs/constants/profile-download-keys"

// has one permission
export const checkHasPermission = (permissions = [], args = {}) =>
    permissions.length === 0 || permissions.filter((permission) => checkPermission(permission, args)).length

// has all permissions
export const checkHasAllPermissions = (permissions, args = {}) =>
    permissions.filter((permission) => checkPermission(permission, args)).length === permissions.length

// check if a value exists in an array of valid values
export const checkValueExists = (validTypes, currentType) => validTypes.length === 0 || validTypes.includes(currentType)

// has at least one piece of valid data
export const checkHasValidData = (objData) => objData.length === 0 || objData.filter((data) => !!data).length

// all data is valid
export const checkIsAllValidData = (objData) =>
    !objData || objData.length === 0 || objData.length === objData.filter((data) => !!data).length

// check to see if any object in an array, has a field (determined by the key)
// that is in validTypes
export const checkIfArrayIncludes = (valuesArray, validTypes, key) =>
    validTypes.length === 0 || (valuesArray && valuesArray.filter((value) => validTypes.includes(value[key])).length)

/**
 * Filters profiles tab by the feature selecting the tabs. For mobile
 * and desktop, tabs are only excluded if they specifically have tab.isMobile = False / tab.isDesktop=False.
 * So, tab.isMobile = undefined means the tab is allowed on mobile.
 *
 * @param  {Object} options  [{ isMobile: boolean, isDLC: boolean }]
 * @return {Boolean}         [whether the tab should be included or not]
 */
export const filterTabByLocation =
    ({ isMobile, isDLC } = {}) =>
    (tab) => {
        switch (true) {
            case isDLC:
                return tab.dlcKey && Object.keys(dlcKeys).includes(tab.dlcKey)
            case isMobile:
                return tab && !tab.isDesktop && tab.isMobile !== false
            default:
                return tab && !tab.isMobile && tab.isDesktop !== false
        }
    }
